import Api from '@/services/api';
import { BindFilesToBeraJobSummaryRequest } from '../../hooks/types/request';

export class BeraJobFilesService {
	async bindFilesToBeraJobSummary(params: BindFilesToBeraJobSummaryRequest) {
		const { data } = await Api.post(`/bera/job-summary/files/bind`, params);
		return data;
	}
}
